import React, { useContext } from 'react';
import { LangContext, MenuContext } from '../../../context/DataContext';

function SidebarSoporteIPv6EquiposCPEV1() {
    const { myLang } = useContext(LangContext);

    const { activeAnchor, scrollToAnchor } = useContext(MenuContext)

    const menuItems = [
        { id: 'p1', anchor: 'resumen', label: 'Resumen' },
        { id: 'p2', anchor: 'introduccion', label: 'Objetivo' },
        { id: 'p3', anchor: 'motivo', label: 'Motivo' },
        { id: 'p4', anchor: 'alcance', label: 'Alcance' },
        { id: 'p5', anchor: 'introduccion', label: 'Introducción' },
        { id: 'p6', anchor: 'consideraciones-iniciales', label: 'Consideraciones Iniciales' },
        { id: 'p7', anchor: 'mecanismos-de-transicion', label: 'Mecanismos de Transición' },
        { id: 'p8', anchor: 'ipv4-as-a-service', label: 'IPv4 as a Service' },
        { id: 'p9', anchor: 'recoleccion-de-informacion', label: 'Recolección de Información' },
        { id: 'p10', anchor: 'encuesta-a-isps', label: 'Encuestas a ISPs' },
        { id: 'p11', anchor: 'consultas-a-fabricantes-de-cpes', label: 'Consultas a Fabricantes de CPEs' },
        { id: 'p12', anchor: 'conclusiones', label: 'Conclusiones' },
        { id: 'p13', anchor: 'referencias', label: 'Referencias' }
    ];

    const ReportData = () => {
       return(
            <nav>
                <button>
                    Informe sobre soporte de IPv6 en equipos CPE - Versión 1 (2020)
                    <i className="fas fa-angle-down" />
                </button>
                <ul className="active">
                    {menuItems.map(({ id, anchor, label }) => (
                        <li key={id}>
                            <a
                                href={`#${anchor}`}
                                className={activeAnchor === id ? 'active' : null}
                                onClick={() => scrollToAnchor(id)}
                            >
                                {label}
                            </a>
                        </li>
                    ))}
                </ul>
            </nav>
        )
    }
    return (
        <>
            {myLang === 'es' || myLang === 'en' || myLang === 'pt' ?
                <ReportData />
            : null }
        </>


    )
}

export default SidebarSoporteIPv6EquiposCPEV1
